import { useMemo } from 'react';
import { UserApi } from '../UserApi';
export const useUserApi = userApiEndpoint => {
  const userApi = useMemo(() => new UserApi("https://".concat(userApiEndpoint)), [userApiEndpoint]);
  const getUserGroups = async userOid => {
    try {
      const groups = await userApi.getUserGroups(userOid);
      return groups;
    } catch (error) {
      console.log(error);
      return [];
    }
  };
  const getUserMail = async userOid => {
    try {
      const mail = await userApi.getUserMail(userOid);
      return mail;
    } catch (error) {
      console.log(error);
      return '';
    }
  };
  return {
    getUserGroups,
    getUserMail
  };
};